/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 优惠券详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  couponId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.CouponDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/coupon/${couponId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
